import type React from 'react'

import css from '../../styles.module.scss'

export const ChartLegend: React.FC = () => (
  <div className={css.legend}>
    <span className={css.legend_item}>
      <i className={css.dot_read} />
      Reading
    </span>
    <span className={css.legend_item}>
      <i className={css.dot_write} />
      Writing
    </span>
  </div>
)
